import { render, staticRenderFns } from "./d-main-image.vue?vue&type=template&id=0a16d1a5&lang=pug&"
import script from "./d-main-image.vue?vue&type=script&lang=js&"
export * from "./d-main-image.vue?vue&type=script&lang=js&"
import style0 from "./d-main-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a16d1a5')) {
      api.createRecord('0a16d1a5', component.options)
    } else {
      api.reload('0a16d1a5', component.options)
    }
    module.hot.accept("./d-main-image.vue?vue&type=template&id=0a16d1a5&lang=pug&", function () {
      api.rerender('0a16d1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/displays/d-main-image.vue"
export default component.exports